export default __webpack_public_path__ + "static/media/iconCheckCircle.fb9493fa.svg";